import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=efd535fe&scoped=true&lang=pug&"
import script from "./ForgotPassword.vue?vue&type=script&lang=js&"
export * from "./ForgotPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd535fe",
  null
  
)

export default component.exports